export default "__VITE_ASSET__52d1e482__"